import { Box, type BoxProps } from '@mui/material';
import { Link } from 'react-router';

import { url } from '../../../../appRouter/url';
import { type AkaVeranstaltungId } from '../../../../dtos';

type VeranstaltungEventButtonProps = Pick<BoxProps, 'children'> & {
  readonly eventColor: string;
  readonly akaVeranstaltungId: AkaVeranstaltungId;
};

export const VeranstaltungEventButton = ({
  akaVeranstaltungId,
  eventColor,
  children,
}: VeranstaltungEventButtonProps) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 1,
      color: 'white !important',
      background: eventColor,
    }}
  >
    <Link
      to={url.veranstaltung.details(akaVeranstaltungId)}
      target="_blank"
      style={{ color: 'inherit', textDecoration: 'none' }}
    >
      {children}
    </Link>
  </Box>
);
